import React, { useContext, useMemo } from "react"
import { HelveticaBold } from "common/typographies.js"
import i18n from "i18n"
import PropTypes from "prop-types"
import { getCurrency } from "utils/functions"
import AuthContext from "context/auth/authContext"
import { TOTAL_DECOMPOSITIONS } from "constants/decimals"
import { useDecimalFormatter } from "hooks/useDecimalFormatter"

const DetailsFooter = ({ partidaState, details = [] }) => {
  const { formatValue } = useDecimalFormatter()

  const { user } = useContext(AuthContext)

  const { materialSum, manoDeObraSum, otrosSum } = useMemo(() => {
    if (!Array.isArray(details) || details.length === 0) {
      return {
        materialSum: Number(partidaState?.priceMaterial || 0),
        manoDeObraSum: Number(partidaState?.priceManoDeObra || 0),
        otrosSum: Number(partidaState?.priceOther || 0),
      }
    }

    let accNonPercent = 0
    let material = 0
    let manoDeObra = 0
    let otros = 0

    details.forEach(d => {
      const type = String(d?.type || "").toLowerCase()
      const unity = String(d?.unity || "")
      let price =
        d?.priceReduced !== undefined &&
        d?.priceReduced !== null &&
        d?.priceReduced !== ""
          ? Number(d.priceReduced)
          : Number(d?.price || 0)
      let qty = Number(d?.quantity || 0)
      if (unity === "%") {
        qty = qty > 1 ? qty / 100 : qty
      }

      const priceForCalc =
        unity === "%" && type === "coste" ? accNonPercent : price
      const importe = priceForCalc * (qty + (Number(d?.waste) || 0))

      if (type === "material") material += importe
      else if (type === "manodeobra") manoDeObra += importe
      else otros += importe

      if (unity !== "%") {
        accNonPercent += price * qty
      }
    })

    return {
      materialSum: material,
      manoDeObraSum: manoDeObra,
      otrosSum: otros,
    }
  }, [details, partidaState])
  return (
    <div
      className="inline"
      style={{
        width: "100%",
        borderTop: "1px solid #C4C4C4",
        flexDirection: "column",
        padding: "15px 0 0 15px",
      }}
    >
      <div className="inline" style={{ width: "100%" }}>
        <div>
          <HelveticaBold
            style={{
              color: "#414141",
              fontSize: "12px",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            {i18n.t("Materiales")}
          </HelveticaBold>
        </div>
        <div style={{ marginLeft: "auto", marginRight: "10%" }}>
          <HelveticaBold
            style={{
              color: "#414141",
              fontSize: "12px",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            {`${formatValue(materialSum, TOTAL_DECOMPOSITIONS)} ${getCurrency(user["custom:currency"])}`}
          </HelveticaBold>
        </div>
      </div>
      <div className="inline" style={{ width: "100%" }}>
        <div>
          <HelveticaBold
            style={{
              color: "#414141",
              fontSize: "12px",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            {i18n.t("Mano de obra")}
          </HelveticaBold>
        </div>
        <div style={{ marginLeft: "auto", marginRight: "10%" }}>
          <HelveticaBold
            style={{
              color: "#414141",
              fontSize: "12px",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            {`${formatValue(manoDeObraSum, TOTAL_DECOMPOSITIONS)} ${getCurrency(user["custom:currency"])}`}
          </HelveticaBold>
        </div>
      </div>
      <div className="inline" style={{ width: "100%" }}>
        <div>
          <HelveticaBold
            style={{
              color: "#414141",
              fontSize: "12px",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            {i18n.t("Otros")}
          </HelveticaBold>
        </div>
        <div style={{ marginLeft: "auto", marginRight: "10%" }}>
          <HelveticaBold
            style={{
              color: "#414141",
              fontSize: "12px",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            {`${formatValue(otrosSum, TOTAL_DECOMPOSITIONS)} ${getCurrency(user["custom:currency"])}`}
          </HelveticaBold>
        </div>
      </div>
      <div className="inline" style={{ width: "100%" }}>
        <div>
          <HelveticaBold
            style={{
              color: "#414141",
              fontSize: "12px",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            {i18n.t("Total")}
          </HelveticaBold>
        </div>
        <div style={{ marginLeft: "auto", marginRight: "10%" }}>
          <HelveticaBold
            style={{
              color: "#414141",
              fontSize: "12px",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            {`${formatValue(materialSum + manoDeObraSum + otrosSum, TOTAL_DECOMPOSITIONS)} ${getCurrency(user["custom:currency"])}`}
          </HelveticaBold>
        </div>
      </div>
    </div>
  )
}

DetailsFooter.propTypes = {
  partidaState: PropTypes.object.isRequired,
  details: PropTypes.array,
}

export default DetailsFooter
